import { gql } from "@apollo/client";

export const GET_STACK_LOGS_DOWNLOAD_URL = gql`
  query GetStackLogsDownloadURL($stackId: ID!, $runId: ID!, $state: RunState!, $stateVersion: Int) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        logsDownloadURL(state: $state, stateVersion: $stateVersion) {
          url
          expired
          ongoing
        }
      }
    }
  }
`;

export const GET_MODULE_LOGS_DOWNLOAD_URL = gql`
  query GetModuleLogsDownloadURL($moduleId: ID!, $runId: ID!, $state: RunState!) {
    module(id: $moduleId) {
      id
      run(id: $runId) {
        id
        logsDownloadURL(state: $state) {
          url
          expired
          ongoing
        }
      }
    }
  }
`;

export const GET_STACK_LOGS_SANITIZED = gql`
  query GetStackLogsSanitized(
    $stackId: ID!
    $runId: ID!
    $state: RunState!
    $token: String
    $stateVersion: Int
  ) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token, stateVersion: $stateVersion, sanitize: true) {
          exists
          expired
          finished
          hasMore
          ongoing
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;

export const GET_MODULE_LOGS_SANITIZED = gql`
  query GetModuleLogsSanitized($moduleId: ID!, $runId: ID!, $state: RunState!, $token: String) {
    module(id: $moduleId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token, sanitize: true) {
          exists
          expired
          finished
          hasMore
          ongoing
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;
